export const hotRank = [
  { rank: 1, id: 'n01', title: '综艺分组名单时间线还原', heat: '9.8万', tag: '首发' },
  { rank: 2, id: 'n02', title: '电竞联赛爆冷止步八强', heat: '8.6万', tag: '升热' },
  { rank: 3, id: 'n03', title: '头部主播深夜回应争议', heat: '7.9万', tag: '更新' },
  { rank: 4, id: 'n04', title: '都市剧大结局口碑两极', heat: '7.1万', tag: '热议' },
  { rank: 5, id: 'n05', title: '音乐节档期临时调整', heat: '5.7万', tag: '跟进' },
  { rank: 6, id: 'n06', title: '演员团队变动传闻待确认', heat: '5.0万', tag: '核实' },
  { rank: 7, id: 'n07', title: '异地三年话题真实经历', heat: '4.4万', tag: '话题' },
  { rank: 8, id: 'n08', title: '达人账号风格突变成谜', heat: '3.9万', tag: '首发' },
];

export const brandStats = [
  { value: '9', suffix: '大', label: '覆盖圈子', icon: 'ri-layout-grid-line' },
  { value: '6', suffix: '分钟', label: '平均上首页', icon: 'ri-timer-flash-line' },
  { value: '24', suffix: '小时', label: '值守更新', icon: 'ri-radar-line' },
  { value: '120', suffix: '万+', label: '月度阅读', icon: 'ri-eye-line' },
];

export const faqList = [
  {
    q: '黑料爆料上的内容多久更新一次？',
    a: '情报流全天滚动更新，编辑值守时间为每日 09:00 至 23:30。热门事件平均在 6 分钟内进入首页实时列表，重大反转会直接更新原有时序条目，不会另开一条掩盖前后关系。',
  },
  {
    q: '为什么有些内容会被标记为「待确认」？',
    a: '当一条信息只有单一来源、来源已被删除，或双方说法存在明显冲突时，我们会把它标记为「待确认」，同时列出接下来需要观察的公开信号。标记不会自动撤销，需要新的公开证据出现。',
  },
  {
    q: '站内的热度数值是怎么来的？',
    a: '热度由阅读量、讨论量与单位时间增速加权得出，用于呈现话题的相对关注度，并不代表内容真实性。数值每个整点重算一次，因此你可能看到同一条内容的热度上升或回落。',
  },
  {
    q: '我看到的爆料和后来官方说明不一样，会更新吗？',
    a: '会。凡是进入过首页的信息，我们都会在原条目内补充后续进展，并用「更新」「核实」标签标注。如果最终被公开证据否定，我们会在原文顶部追加更正说明，而不是直接删除。',
  },
  {
    q: '我可以投稿或提供线索吗？',
    a: '可以。在「关于我们」页面底部有投稿与联系表单，选择「提供线索」即可。建议同时说明信息来源与可公开的部分，编辑会按核查流程处理，不会公开你的联系方式。',
  },
  {
    q: '站内的图片是事件现场照片吗？',
    a: '不是。为保护相关当事人并避免误用他人影像，站内配图统一使用抽象氛围图，仅用于区分栏目与阅读节奏，与具体事件内容无关。',
  },
];

export const testimonialList = [
  {
    name: '林一野',
    role: '连续访问 280 天',
    avatar:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20portrait%20silhouette%20of%20a%20person%20in%20profile%20against%20a%20deep%20charcoal%20background%20with%20soft%20crimson%20rim%20light%2C%20editorial%20minimal%20style%2C%20high%20contrast%2C%20film%20grain&width=200&height=200&seq=gg-ava-01&orientation=squarish',
    quote:
      '最舒服的是时间线。别的平台一条瓜要翻五个帖子，这里一条就把前后顺序排好了，看完不用再猜哪句是旧闻。',
  },
  {
    name: '壳壳',
    role: '综艺分类常客',
    avatar:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20portrait%20silhouette%20with%20short%20hair%20against%20a%20deep%20charcoal%20background%20and%20warm%20amber%20side%20light%2C%20editorial%20minimal%20style%2C%20high%20contrast%2C%20film%20grain&width=200&height=200&seq=gg-ava-02&orientation=squarish',
    quote:
      '标记「待确认」这点我很喜欢。很多地方为了抢首发什么都不标，这里至少告诉你是几手信息。',
  },
  {
    name: '老曹',
    role: '电竞板块读者',
    avatar:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20portrait%20silhouette%20with%20glasses%20against%20a%20deep%20charcoal%20background%20with%20cold%20teal%20rim%20light%2C%20editorial%20minimal%20style%2C%20high%20contrast%2C%20film%20grain&width=200&height=200&seq=gg-ava-03&orientation=squarish',
    quote:
      '赛后争议那篇把两份说法并排放，比只放一边舒服多了。至少能自己判断，而不是被带着走。',
  },
];

export const principleList = [
  {
    title: '先看来源，再看内容',
    desc: '每条进入首页的信息都会标注来源数量与可信状态，单一来源的内容统一带上「待确认」标记。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '保留完整时间顺序',
    desc: '反转发生时在原条目内追加进展，而不是用新内容覆盖旧内容，让来龙去脉始终可追溯。',
    icon: 'ri-history-line',
  },
  {
    title: '不公开个人隐私',
    desc: '不发布联系方式、住址、证件等个人信息，配图统一使用抽象氛围图，避免误用他人影像。',
    icon: 'ri-lock-2-line',
  },
  {
    title: '错了就改，并说明',
    desc: '若内容被公开证据否定，会在原文顶部追加更正说明并保留原记录，不做无声删除。',
    icon: 'ri-error-warning-line',
  },
];

export const aboutSections = [
  {
    heading: '我们是谁',
    paragraphs: [
      '黑料爆料是一个专注娱乐与网络热点的实时情报站。我们不生产结论，而是把散落在各个讨论群的碎片信息，按时间与热度重新排好，让你打开首页就能看见最新动态。',
      '站内内容覆盖娱乐圈、网红圈、综艺、影视、音乐、电竞、情感与公共热点九个圈子，所有公开可见的节点都会被整理进同一条时间线里。',
    ],
  },
  {
    heading: '网站定位',
    paragraphs: [
      '我们希望成为「不用跳转」的那一站。你不需要在五个社群之间来回翻找，也不需要在一堆重复标题里辨认哪条最早——首页的实时列表已经把最新动态摆在最前面。',
      '对读者来说，这里是一个可以快速看懂来龙去脉的地方；对提供线索的人来说，这里是一个愿意标注信息状态、也愿意更正的地方。',
    ],
  },
  {
    heading: '发展理念',
    paragraphs: [
      '速度与克制并不矛盾。我们追求首发，但首发之后更重要的工作是核查：这条信息有几个来源、能不能对应上、有没有被公开证据推翻。',
      '因此站内的标签体系不是为了好看，而是为了让每一条内容都带上自己的可信程度，让读者在点开之前就知道自己将看到什么。',
    ],
  },
];